import capitalize from 'lodash/capitalize';

export const generateFullName = (
  firstName: string,
  lastName: string,
  middleName?: string,
) =>
  [capitalize(firstName), capitalize(middleName), capitalize(lastName)]
    .filter(Boolean)
    .join(' ');

export const getNameParts = (
  fullName: string,
): { firstName: string; lastName: string; middleName?: string } => {
  const parts = fullName.split(' ');

  const firstName = parts[0];
  let lastName = '';
  let middleName = '';

  if (parts.length > 1) {
    lastName = parts[parts.length - 1];
  }

  if (parts.length > 2) {
    middleName = parts.slice(1, -1).join(' ');
  }

  return {
    firstName: capitalize(firstName),
    lastName: lastName ? capitalize(lastName) : '',
    middleName: middleName ? capitalize(middleName) : undefined,
  };
};
